import React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from '@Redux/type';
import { AppState } from '@Redux/store';
import Repeater from '@Utils/Repeater';
import { ContestView } from '@Selectors/builder/myBuilder/show/view/ContestView';
import ContestComponent from './ContestComponent';
import { myContestsPresenter } from '@Selectors/builder/myBuilder/show/myContestsPresenter';
import bt_tool_pairing from '@Images/en/bt_tool-pairing.png';
import ContestNew from './new/contest/ContestNew';
import { MyBoardPresenter } from '@Selectors/builder/myBuilder/MyBoardPresenter';
import { FormattedMessage } from 'react-intl';
import { defaultMessages } from '@I18n/default';
import myBuilderSlice from '@Redux/reducers/builder/myBuilder.slice';
import { MyBuilderActionState } from '@Stores/builder/MyBuilderState';

const MyContestsComponent: React.FC<MyContestsComponentProps> = ({ myBoard, contests, createContest }) => {

  return (
    <section>
      {myBoard.createContest && <ContestNew />}
      {contests.length == 0 && <div />}
      {contests.length > 0 && (<div>
        <h2 className="text-center"><FormattedMessage {...defaultMessages.tournamentContestIndexTitle} /></h2>
        <div className="content row justify-content-center">
          <div className="col-6 col-sm-6 col-md-3 col-lg-3 col-xl-2 army_list_row">
            <a href="#" onClick={(e) => createContest(e)}>
              <img src={`${process.env.CDN ?? ''}${bt_tool_pairing}`} className="img-fluid w-100" alt="" />
              <h4 className="boxtitre"><FormattedMessage {...defaultMessages.armyListIndexContest} /></h4>
            </a>
          </div>
          <Repeater data={contests} indexPrefix="folder">
            {
              (item: ContestView) => <ContestComponent contest={item} />
            }
          </Repeater>
        </div>
      </div>)}
    </section>
  );
};

const mapStateToProps = (state: AppState) => ({
  myBoard: MyBoardPresenter(state),
  contests: myContestsPresenter(state)
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  createContest: (e: any) => {
    e.preventDefault();
    dispatch(myBuilderSlice.actions.setRequest(MyBuilderActionState.ContestCreation));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(MyContestsComponent);

type MyContestsComponentProps = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>
